import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { replaceToUpperCase } from 'shared/modules';
import { posted } from 'shared/helpers/moment';
// import uaFlag from 'shared/assets/images/ua_flag.png';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CheckedVinBlock.css';

class CheckedVinBlock extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    isMobile: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    isMobile: false,
  };

  render() {
    const { advert, intl, isMobile } = this.props;
    const { locale } = intl;

    const {
      vehreg_info: vehregInfo,
      make: { id: makeId },
      model: { id: modeleId },
      year,
      engine: adverEngine,
      color: { id: colorId },
      capacity: advertCapacity,
      characteristics,
      // reg_number: regNumber,
    } = advert;

    const { capacity: charCapacity, engine: charEngine } = characteristics;
    let capacity = advertCapacity || (charCapacity && charCapacity.title);
    const engineId = adverEngine.id || (charEngine && charEngine.id);

    if (capacity && capacity.toString().includes(',')) capacity = capacity.split(',').join('.');

    const {
      make: { id: makeVehregId, title: makeTitle },
      model: { id: modelVehregId, title: modelTitle },
      year: yearVehreg,
      engine: { id: engineVehregId, title: engineTitle },
      color: { id: colorVehregId, title: colorTitle, slug: colorSlug },
      capacity: capacitySmVehreg,
      operation_date: operationDate,
      // regnum_match: regnumMatch,
      vin_match: vinMatch,
    } = vehregInfo;
    const capacityVehreg = capacitySmVehreg ? (capacitySmVehreg / 1000).toFixed(1) : null;
    const hasCapacity = !!capacityVehreg || !!capacity;

    const isCheckedCapacity =
      engineId && engineVehregId === engineId && (!hasCapacity || +capacityVehreg === +capacity);

    return (
      <div className={s.root}>
        <span className={s.title}>
          <FormattedMessage id={'Проверено avtobazar.ua по реестрам МВД Украины'} />
        </span>
        <div className={s.carNumberBlock}>
          {/* {regnumMatch && ( */}
          {/*  <span className={cx(s.numberInfo, s.regNumber)}> */}
          {/*    <span className={s.uaCarNum} /> <img src={uaFlag} alt="" /> */}
          {/*    {regNumber} */}
          {/*  </span> */}
          {/* )} */}
          {vinMatch && (
            <span className={s.numberInfo}>
              <FormattedMessage id={'Проверенный VIN-код'} />
            </span>
          )}
        </div>
        <ul className={s.infoList}>
          <li className={cx(s.checkbox, { [s.checkboxTop]: isMobile })}>
            <input
              type="checkbox"
              checked={makeVehregId === makeId && modelVehregId === modeleId && year === yearVehreg}
              onChange={() => {}}
            />
            <span className={s.itemTitle}>
              <FormattedMessage id={'Марка, модель, год'} />
            </span>
            <span>{`${makeTitle} ${modelTitle} ${yearVehreg}`}</span>
          </li>
          <li className={cx(s.checkbox, { [s.checkboxTop]: isMobile })}>
            <input type="checkbox" checked={isCheckedCapacity} onChange={() => {}} />
            <span className={s.itemTitle}>
              <FormattedMessage id={'двигатель'} />
            </span>
            <span>{`${engineTitle ? intl.formatMessage({ id: engineTitle }) : ''} ${
              hasCapacity ? `${capacityVehreg} л` : ''
            }`}</span>
          </li>
          <li className={cx(s.checkbox, { [s.checkboxTop]: isMobile })}>
            <input type="checkbox" checked={colorVehregId === colorId} onChange={() => {}} />
            <span className={s.itemTitle}>
              <FormattedMessage id={'Цвет'} />
            </span>
            <span>
              <span style={{ backgroundColor: `#${colorSlug}` }} className={s.colorSquare} />
              {replaceToUpperCase(intl.formatMessage({ id: colorTitle }))}
            </span>
          </li>
          <li className={cx(s.checkbox, { [s.checkboxTop]: isMobile })}>
            <input type="checkbox" checked={operationDate} onChange={() => {}} />
            <span className={s.itemTitle}>
              <FormattedMessage id={'Последняя операция'} />
            </span>
            <span>{posted(operationDate, locale)}</span>
          </li>
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(CheckedVinBlock));



// WEBPACK FOOTER //
// ./src/shared/components/CheckedVinBlock/CheckedVinBlock.js